import React, { useState } from 'react';
import { UserInfo } from "@shared/models/user.models";
import { SpaceBetweenRow } from "../StyleComponents";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { SimpleSpinner } from '@shared/ui/atoms/SimpleSpinner';
import { Switch } from '@shared/ui/atoms/Switch';
import { updateCurrentUser } from "@shared/store/auth.duck";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { UpdateUserField, updateUserField } from '@features/settings/services/UserService';
import { Section } from '@shared/ui/organisms/layout/Layout';

export function UserAccessPermittedControl(props: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const onChange = async (value: boolean) => {
    if (props.userInfo) {
      try {
        setIsLoading(true);
        await updateUserField(props.userInfo.userId, UpdateUserField.accessPermitted, value);
        dispatch(updateCurrentUser(true));
      } finally {
        setIsLoading(false);
      }
    }
  }

  if (!props?.userInfo) {
    return null;
  }

  return (
    <Section>
      <SpaceBetweenRow>
        <BodyRegular weight={600} colour={Colours.blue}>{t('settings-page.edit-user.access-permitted-title')}</BodyRegular>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!props?.userInfo?.accessPermitted} label="" onChange={onChange}/>}
      </SpaceBetweenRow>
      <BodyRegular style={{marginTop: -8, marginBottom: 24}}>{t('settings-page.edit-user.access-permitted-description')}</BodyRegular>
    </Section>
  )
}

interface Props {
  userInfo?: UserInfo;
}
